module.exports = __webpack_public_path__ + "static/mainImage-b06c81a2170ce2c05608f1a6a212ba2b.jpg";